module.exports = __webpack_public_path__ + "static/media/4.3f8b1fa9.jpg";